import { CommonModule } from '@angular/common';
import { CheckEmailComponent } from '../check-email/check-email.component';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { Observer } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  imports: [
    CheckEmailComponent,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  styleUrls: [
    './forgot-password.component.css',
    '../../globals.css',
    '../../styleguide.css',
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent {
  constructor(private apiService: ApiService) {}

  isSubmitted = false;
  emailAddress: string = '';
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  isEmailSubmitted = false;

  updateIsClicked(value: boolean) {
    this.isSubmitted = value;
  }

  validateSend() {
    if (
      this.emailFormControl.hasError('email') ||
      this.emailFormControl.hasError('required')
    ) {
      this.isEmailSubmitted = true;
      return;
    }

    this.resetPassword(this.emailFormControl.value ?? '');
  }

  onInputChange() {
    if (!this.emailFormControl || this.emailFormControl.value === '') {
      this.emailFormControl.setErrors(null);
      this.isEmailSubmitted = false;
    }
  }

  resetPassword(email: string) {
    if (!email || email === '') {
      this.emailFormControl.setErrors({
        customError: 'Email is required.',
      });
      return;
    }

    this.isSubmitted = true;

    this.apiService.resetPassword(email).subscribe({
      next: (data: any) => {},
      error: (error: any) => {},
    } as Observer<any>);
  }
}
